export default "__VITE_ASSET__CvxqcZzX__"